module.exports = __webpack_public_path__ + "static/media/get-started-1-1.b5af8369.svg";